<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.uniq_id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.title}}
                                <small class="text-muted mb-0">
                                    {{__t('group_info')}}
                                </small>
                            </h5>
                        </div>
                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>

                                    <component
                                        @on_group_change="on_group_change"
                                        v-bind:is="tab.index"
                                        :group="item"
                                    >
                                    </component>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item_id > 0">
                    {{ __t('REMOVE') }}
                </button>

                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save_item" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import group_info from "./tabs/group_info.vue";
    import group_products from "./tabs/group_products.vue";
    import group_attached_products from "./tabs/group_attached_products.vue";
    import group_translate from "./tabs/group_translate.vue";

    export default {
        components : {
            group_info,
            group_products,
            group_attached_products,
            group_translate
        },
        name: "group_modal",
        props : {
            modal_position : {
                type : String,
                default : "right"
            },
        },
        data() {
            return {
                item_id : 0,
                item: {
                    "id" : 0,
                    "title" : "",
                    "uniq_id" : "",
                    min_qual : 0,
                    max_qual : 10
                },
                is_load: false,
                is_show_modal: false,
                is_external_modal : false,
                tabs : []
            }
        },

        created () {
            EventBus.$on("group_edit",id => this.work_click(id));
            EventBus.$on("group_ext_edit",id => this.work_click_ext(id));
            EventBus.$on("close_group",this.close);
        },

        methods : {
            on_group_change(event) {

                if(event.hasOwnProperty("type")) {
                    let atr_name = event.type;

                    if(event.hasOwnProperty("value")) {
                        let atr_val = event.value;

                        if (this.item.hasOwnProperty(atr_name)) {
                            this.item[atr_name] = atr_val;
                        }

                        if (atr_name === 'products') {
                            this.item.products = atr_val.map(item => {
                                return item.id;
                            });
                        }
                    }

                    if(event.hasOwnProperty("prod") && atr_name === "override") {

                        let prod = event.prod;

                        if (!this.item.hasOwnProperty('overrides')) {
                            this.item.overrides = [];
                        }

                        if (!prod.has_override) {
                            this.item.overrides = this.item.overrides.filter(p => p.prod_id !== prod.prod_id);
                        } else {
                            const idx = this.item.overrides.findIndex(p => p.prod_id === prod.prod_id);

                            if (idx >= 0) {
                                this.item.overrides[idx] = prod;
                            } else {
                                this.item.overrides.push(prod);
                            }
                        }
                    }
                }
            },

            work_click_ext(_id) {
                this.is_external_modal = true;
                this.work_click(_id);
            },

            work_click(_id) {
                this.item_id = _id;
                this.is_show_modal = true;
                this.load_group();
            },

            get_tab_title (tab) {
                if(tab.count > 0) {
                    return tab.title;
                }
                return tab.title;
            },

            set_active (obj) {
                for (let tab in this.tabs) {
                    this.tabs[tab].is_active = false;
                }

                this.tabs[obj].is_active = true;
                EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
            },

            send_ext_trigger(type,ext_params = {}) {
                let send = {
                    'type'  : type,
                    'group' : this.item,
                    'ext_params' : ext_params,
                };

                EventBus.$emit('group_finish',send);
                this.$emit('on_group_finish',type,send)
            },

            async remove() {
                let self = this;
                const is_ok = confirm_me(this.__t("ARE_SURE"));
                is_ok.then(res => {
                    self.is_load = true;
                    api.delete('/internal/v1/catalog/modifiers/groups/'+ parseInt(this.item.id)).then(({data}) => {
                        self.is_load = false;
                        if (data.status === "operation_success") {
                            if(!self.is_external_modal) {
                                window.location.reload();
                            }
                            else {
                                self.send_ext_trigger('remove');
                            }
                        }
                    }).catch(({response}) => {
                        self.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message, type: "danger",
                            title: response.data.status,
                            position : "b-toaster-top-left"
                        })
                    });
                });
            },

            async save_item() {
                this.is_load = true;
                await api.put('/internal/v1/catalog/modifiers/groups/'+ parseInt(this.item.id),this.item).then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        EventBus.$emit("close_group");
                        EventBus.$emit("reload_groups");

                        EventBus.$emit('save_translation',data.data.id,'group', this.Onclose);
                        this.send_ext_trigger('save',data.data);
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left",
                    })
                });
            },

            Onclose() {

            },

            close () {
                this.send_ext_trigger('close');
                this.item = {
                    id : 0,
                    title : "",
                    uniq_id : "",
                    min_qual : 0,
                    max_qual : 0
                };

                this.tabs = [];
                this.is_show_modal = false;
                this.is_external_modal = false;
            },

            async load_group () {
                this.is_load = true;
                this.tabs = [];
                await api.get('/internal/v1/catalog/modifiers/groups/' + parseInt(this.item_id)).then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.item = data.data;
                        this.push_tabs();
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
                });
            },

            push_tabs() {
                this.default_tabs.map(item => {
                    this.tabs.push({
                        title: item.title,
                        disabled: false,
                        is_active: false,
                        is_load: false,
                        index: item.index,
                        html: ''
                    });
                });
            },
        },

        computed : {

            default_tabs() {
                let base = [
                    {
                        "title": this.__t('MAIN_SETTINGS'),
                        "index": "group_info",
                        is_active:true,
                    },
                ];

                if(this.is_external_modal || this.item.id === 0) {
                    base.push({
                        "title": this.__t('GROUP_PRODUCTS'),
                        "index": "group_products",
                        is_active:true,
                    });
                }
                else {
                    base.push({
                        "title": this.__t('GROUP_ATTACHED_PRODUCTS'),
                        "index": "group_attached_products",
                        is_active:true,
                    });

                }

                base.push({
                    "title": this.__t('GROUP_TRANSLATE'),
                    "index": "group_translate",
                    is_active:true,
                });

                return base;
            },


            dialog_class_draw () {
                if(this.modal_position === "left") {
                    return "modal-dialog-left modal-lg";
                }

                return "modal-dialog-right modal-lg";
            },
        }
    }
</script>

<style scoped>

</style>
